import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { APP_URL_HOME } from '../../../const';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { appHeight } from '../../../utils/helper';
import styles from './styles.module.scss';

const FallbackPage = ({ error, resetErrorBoundary }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [_, height] = useWindowSize();
    appHeight(height);
    console.log(error);

    return (
        <div className={styles.wrapper}>
            <div className={classNames('container relative', styles.inner)}>
                <div className={styles.titles}>
                    <h1 className={styles.title}>{t('errors.wrong404')}</h1>
                    <p className={styles.subtitle}>{t('errors.errorBoundary')}</p>
                </div>
                <div className={styles.buttons}>
                    <button
                        onClick={() => {
                            resetErrorBoundary();
                            navigate(APP_URL_HOME);
                        }}
                        className={styles.btn}
                    >
                        {t('buttons.toHome')}
                    </button>
                    <button onClick={resetErrorBoundary} className={styles.btn}>
                        {t('buttons.tryAgain')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FallbackPage;
